import React from "react";
import Roles from "modules/roles";

const RolesPage = () => {
  return <Roles />;
};

export default RolesPage;
